/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';

const SortablePlaceholder = ({ id, containerId, children }) => {
  const { attributes, listeners, setNodeRef } = useSortable({
    id,
    data: { sortable: { containerId } }
  });

  return (
    <div ref={setNodeRef} data-id={id} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

SortablePlaceholder.propTypes = {
  id: PropTypes.string.isRequired,
  containerId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export { SortablePlaceholder };
